import React from "react";
import "./MoleculesDisplay.css";
import MoleculeCard from "./MoleculeCard.js";
import { useState } from "react";
import ResultInfoText from "../ResultsTable/ResultInfoText.js";

const MoleculesDiv = ({ molecules, startingDisplay = 6, displayStep = 9}) => {
  const [displayNumber, setDisplayNumber] = useState(startingDisplay);

  return (
    <>
    <div className="molecules-container">
      {molecules.slice(0, displayNumber).map((molecule, index) => (
        <MoleculeCard key={index} molecule={molecule} />
      ))}
    </div>
    <div >
    {displayNumber < molecules.length && (
      <>
      <button
        className="basic-button"
        onClick={() => setDisplayNumber(displayNumber + displayStep)}
      >
        Show more
      </button>
      <ResultInfoText
        text={`Showing ${displayNumber} of ${molecules.length} molecules`}
        row={1}/>
        </>
    )}
    </div>
   </> 
  );
};
export default MoleculesDiv;